import React from 'react';
import { GatsbyImage, StaticImage } from 'gatsby-plugin-image';
import Video from '../../../components/Video';
import CloudinaryMedia from '../../../components/CloudinaryMedia';
import Cutouts from '../../../components/Cutouts';
import getThemeClass from '../../../utils/getThemeClass';
import styles from './FridgeCard.module.css';

/** @param {FF.ContentfulFridgeCard} props */
export default function FridgeCard({
  backgroundColor,
  className,
  cloudinaryMedia,
  cutouts,
  media,
}) {
  const isImage =
    media?.mimeType.startsWith('image/') ||
    (cloudinaryMedia || [])[0]?.resource_type === 'image';
  const isVideo =
    media?.mimeType.startsWith('video/') ||
    (cloudinaryMedia || [])[0]?.resource_type === 'video';

  if (!media && !cloudinaryMedia) {
    throw new Error('need to provide either image or cloudinaryMedia');
  }

  return (
    <li
      className={`${className} ${getThemeClass(backgroundColor)} ${
        styles.wrapper
      }`}
    >
      <Cutouts cutouts={cutouts} noPadding>
        <div>
          <figure className={styles.fridgeScreen}>
            {cloudinaryMedia && (
              <CloudinaryMedia
                {...cloudinaryMedia[0]}
                className={isVideo ? styles.fridgeVideo : styles.fridgeImage}
                lazyload
                breakpoints={[480, 1000]}
              />
            )}
            {!cloudinaryMedia && media && (
              <>
                {isImage && (
                  <GatsbyImage
                    alt={media.description}
                    className={styles.fridgeImage}
                    image={media.gatsbyImageData}
                    loading="lazy"
                  />
                )}
                {isVideo && (
                  <Video
                    autoPlay
                    className={styles.fridgeVideo}
                    description={media.description}
                    url={media.url}
                  />
                )}
              </>
            )}
          </figure>
          <StaticImage
            className={styles.fridgeWrap}
            alt="Farmer's Fridge Kiosk w/ Screen"
            loading="lazy"
            src="../../../assets/img/fridgeWrap.png"
          />
        </div>
      </Cutouts>
    </li>
  );
}
